import React, { useCallback } from 'react';
import * as trandingTokenService from '../../../services/trandingTokenService';

const useTrandingToken = () => {

    const findToken = useCallback(async (address: string, chainId: number) => {
        try {
            const response = await trandingTokenService.findTrandingToken(address, chainId);
            const roleData = response.data;
            return roleData;
        } catch (error) {
            console.error("Failed to fetch tranding token:", error);
            throw error; 
        }
    }, []);

    return {
        findToken
    };
};

export default useTrandingToken;
